import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import axios from '@src/service/axios';
import { setLoading } from '../../../../@core/components/skelton/store';

export const getEllisiomConfig = createAsyncThunk('elisionSlice/get-elision-configuration', async (_, { dispatch, rejectWithValue }) => {
    try {
        dispatch(setLoading(true));
        let Response = await axios.get('/elision-configuration', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(Response?.data?.data);
    } catch (error) {
        dispatch(setLoading(false));
        console.log('err', error);
        toast.error(error?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(error);
    }
});

export const elisiomConfig = createAsyncThunk('elisionSlice/get-elision-configuration', async (data, { dispatch }) => {
    try {
        dispatch(setLoading(true));
        let Response = await axios.post('/elision-configuration', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(Response?.data?.data);
    } catch (error) {
        dispatch(setLoading(false));
        console.log('err', error);
        toast.error(error?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(error);
    }
});

export const updateElisionStatus = createAsyncThunk('elisionSlice/updateElisionStatus', async (id) => {
    try {
        let Response = await axios.put('/elision-configuration/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(Response?.data?.message || 'WhatsApp Status Changed successfully.');
        return Promise.resolve(Response);
    } catch (error) {
        toast.error(error?.response?.data?.message || 'Something went wrong!');
        console.log('err during update elision status ', error?.response?.data);
        return Promise.reject(error?.response?.data);
    }
});

export const deleteElisionConfig = createAsyncThunk('elisionSlice/deleteElisionConfig', async (deleteId, { dispatch }) => {
    try {
        let Response = await axios.delete('/elision-configuration/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(Response?.data?.message || 'WhatsApp deleted successfully.');
        dispatch(getEllisiomConfig());
        return Promise.resolve(Response);
    } catch (error) {
        toast.error(error?.response?.data?.message || 'Something went wrong!');
        console.log('err', error);
        return Promise.reject(error);
    }
});

export const elisionSlice = createSlice({
    name: 'elisionSlice',
    initialState: {
        elisiondata: [],
        elisionStatus: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getEllisiomConfig.fulfilled, (state, action) => {
            state.elisiondata = action.payload;
            return;
        });
        builder.addCase(updateElisionStatus.fulfilled, (state, action) => {
            state.elisionStatus = action.payload;
            return;
        });
    }
});

export default elisionSlice.reducer;
